import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  TableContainer,
  Box,
  Td,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { FilterHorarios, Passagem as IPassagem } from "../../utils/interfaces";
import { normalizePassagem } from "../../utils/normalizePassagem";
import { usePassagens } from "../../hooks/pdv/useHorarios";
import Swal from "sweetalert2";
import { Passagem } from "./Passagem";
import { Loading } from "../../components/Loading";
import { AxiosErrorResponse } from "../../hooks/pdv/mutationReserva";
import { usePedidoContext } from "../../Context/PedidoContext";
import { MENSAGEM_PENDENCIA_FINANCEIRA_NOVA_VENDA, refreshUser, temPendenciaFinanceira, useShouldShowProvider } from "../../libs/auth";

export function HorariosIda({active}: {active: number}){
  const showProvider = useShouldShowProvider();
  const {clearLayout} = usePedidoContext()
  const { watch, setValue } = useFormContext();
  const [filter, setFilter] = useState<FilterHorarios | undefined>(undefined);
  const search = watch("search");

  const { data, isLoading, isError, error } = usePassagens({ filter, contexto: 'ida', active });

  useEffect(() => {
    if (search !== undefined && active === 0) {
      setFilter(search);
    }
  }, [search, active]);

  async function validarBloqueioFinanceiroNovaVenda() {
    await refreshUser().catch(() => undefined);

    if (!temPendenciaFinanceira()) {
      return false;
    }

    await Swal.fire({
      toast: false,
      position: "center",
      showConfirmButton: true,
      icon: "warning",
      title: "Pendência financeira",
      text: MENSAGEM_PENDENCIA_FINANCEIRA_NOVA_VENDA,
      confirmButtonText: "Ciente",
      allowEscapeKey: false,
      allowOutsideClick: false,
    });

    return true;
  }

  async function handleLayout(passagem: IPassagem){
    if (await validarBloqueioFinanceiroNovaVenda()) {
      return;
    }

    const normalized = normalizePassagem(passagem);
    if(passagem.conexoes.length > 0){
      setValue('conexao', {
        isConnection: true,
        passagem: normalized
      })
      return;
    }

    clearLayout()
    setValue('layout', normalized)
    setValue('selecionada', {...normalized, contexto: 'ida'})
  }

  if (isError) {
    const err = (error as unknown) as AxiosErrorResponse;
    const message =
      err.response?.data?.data?.message ||
      err.response?.data?.message ||
      err.message ||
      "Erro ao buscar passagens.";

    Swal.fire({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      icon: "error",
      timer: 3000,
      title: message,
    });
  }

  const existsData = typeof data !== 'undefined' && data.length > 0;

  return (
    <TableContainer maxHeight={'40vh'} overflowY={'auto'} overflowX={'auto'}>
      {isLoading && <Loading />}
            <Table fontSize={'sm'} colorScheme='gray' variant={existsData ? 'striped': 'simple'}>
              <Thead bg={'#333333'} position={'sticky'} top={0} width={'100%'}>
                <Tr width={'100%'}>
                  <Th color={'white'} fontSize={'small'} fontWeight={'normal'} py={1} px={1} textAlign={'center'} textTransform={'capitalize'}>Horário</Th>
                  <Th color={'white'} fontSize={'small'} fontWeight={'normal'} py={1} px={1} textAlign={'center'} textTransform={'capitalize'} colSpan={2}>Origem x Destino</Th>
                  <Th color={'white'} fontSize={'small'} fontWeight={'normal'} py={1} px={1} textAlign={'center'} textTransform={'capitalize'}>Classe</Th>
                  <Th color={'white'} fontSize={'small'} fontWeight={'normal'} py={1} px={1} textAlign={'center'} textTransform={'capitalize'}>Valor</Th>
                  <Th color={'white'} fontSize={'small'} fontWeight={'normal'} py={1} px={1} textAlign={'center'} textTransform={'capitalize'}>Ass Livre</Th>
                  <Th color={'white'} fontSize={'small'} fontWeight={'normal'} py={1} px={1} textAlign={'center'} textTransform={'capitalize'}>Previsão Chegada</Th>
                  <Th color={'white'} fontSize={'small'} fontWeight={'normal'} py={1} px={1} textAlign={'center'} textTransform={'capitalize'}>Empresa</Th>
                  {showProvider && <Th color={'white'} fontSize={'small'} fontWeight={'normal'} py={1} px={1} textAlign={'center'} textTransform={'capitalize'}>Provedor</Th>}
                </Tr>
              </Thead>
              <Tbody height={'100%'} bg={'white'}>
              {existsData ? (
                data?.map((item) => (
                  <Passagem key={`ida-${item.servico}`} passagem={item} onLayout={handleLayout} />
                ))
                ): (
                <Tr >
                  <Td colSpan={showProvider ? 9 : 8} bg={'white'}>
                    <Box flexDir={'column'} display={'flex'} width={'100%'} height={'100px'} justifyContent={'center'} alignItems={'center'}>
                      
                    </Box>
                  </Td>
                </Tr>
                )}
              </Tbody>
            </Table>
          </TableContainer>
  )
}
